var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-button",
    {
      class: _vm.tipo,
      attrs: {
        type: _vm.tipo,
        disabled: _vm.disabled,
        size: _vm.size,
        loading: _vm.loading
      },
      on: { click: _vm.goTo }
    },
    [
      _c("span", { staticClass: "center" }, [
        _vm.icone && !_vm.loading ? _c("i", { class: _vm.icone }) : _vm._e(),
        _c("b", [_vm._v("  " + _vm._s(_vm.titulo))])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05fcbef9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05fcbef9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/AppButton.vue
// module id = null
// module chunks = 